<script>
import {
  LayoutIcon,
  LifeBuoyIcon,
  ServerIcon,
  RssIcon
} from "vue-feather-icons";

export default {
  components: {LayoutIcon, LifeBuoyIcon, ServerIcon, RssIcon}
};
</script>

<template>
  <div>
    <!-- Features Start -->
    <section
        class="section bg-light feather-bg-img"
        :style="{'background-image': 'url(' + require('@/assets/images/features-bg-img.png') + ')'}"
        id="cities"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="text-center mb-5">
              <h3 class="title mb-3">Города на сервере</h3>
              <p class="text-muted font-size-17">
                Сервер состоит из планет, на каждой планете есть города и места для свободного строительства.
                В городах можно найти все привычные локации для покупок предметов и игры.
              </p>
            </div>
          </div>
        </div>
        <div class="row align-items-center">

          <div class="col-lg-5 offset-lg-1">
            <h3 class="font-weight-semibold line-height-1_4 mb-4">
              <i class="mdi mdi-home-city-outline h2 text-primary mr-3 align-middle"></i>Риджвейл</h3>
            <p class="text-muted font-size-17 mb-4">
              Столица планеты <b>Земля</b>, построен в современном стиле, самый большой город сервера. Это единственный
              город, который свободно доступен пользователям.
            </p>
            <p class="text-muted font-size-17 mb-2">
              <i class="mdi mdi-sword h2 text-primary mr-1 text-muted align-middle"></i>PvP арена
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-shopping h2 text-primary mr-1 text-muted align-middle"></i>Магазин
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-home h2 text-primary mr-1 text-muted align-middle"></i>Жилые кварталы
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-brightness-3 h2 text-primary mr-1 text-muted align-middle"></i>Моб арена
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-map-marker h2 text-primary mr-1 text-muted align-middle"></i>Музей
            </p>
            <div class="mt-5">
              <!--              <a href="javascript: void(0);" class="btn btn-primary mr-2">Read More</a>-->
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-4 mb-lg-0">
              <img src="@/assets/images/ridg.png" alt class="img-fluid d-block mx-auto"/>
            </div>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="mb-4 mb-lg-0">
              <img src="@/assets/images/dalion.png" alt class="img-fluid d-block mx-auto"/>
            </div>
          </div>

          <div class="col-lg-5 offset-lg-1">
            <h3 class="font-weight-semibold line-height-1_4 mb-4">
              <i class="mdi mdi-home-city-outline h2 text-primary mr-3 align-middle"></i>Далион</h3>
            <p class="text-muted font-size-17 mb-4">
              Столица планеты <b>Рея</b>, построен в органическом стиле, весь город как единый организм с большой
              сетью подземных туннелей.
            </p>
            <p class="text-muted font-size-17 mb-2">
              <i class="mdi mdi-sword h2 text-primary mr-1 text-muted align-middle"></i>PvP арена
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-shopping h2 text-primary mr-1 text-muted align-middle"></i>Магазин
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-home h2 text-primary mr-1 text-muted align-middle"></i>Жилые кварталы
            </p>
            <p class="text-muted font-size-17">
              <i class="mdi mdi-gamepad h2 text-primary mr-1 text-muted align-middle"></i>Лобби миниигр
            </p>
            <div class="mt-5">
              <!--              <a href="javascript: void(0);" class="btn btn-primary mr-2">Read More</a>-->
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
